<template>
    <div>
        <van-popup position="bottom" v-model="isShow" @click-overlay="onCancel">
            <van-datetime-picker v-model="currentDate" type="datetime" :cancel-button-text="$t('message.cancel')" :confirm-button-text="$t('message.submit')" :formatter="formatter" @cancel="onCancel" @confirm="onConfirm"/>
        </van-popup>
    </div>
</template>

<script>
    import { lang } from 'vant';
    export default {
        name: "Time",
        props: ['show'],
        data() {
            return {
                isShow: this.show,
                currentDate: new Date(),
            }
        },
        methods: {
            formatter(type, value) {
                return value;
            },
            onCancel() {
                this.isShow = false;
                this.$emit("cancelTime", this.isShow)
            },
            onConfirm(value) {
                this.isShow = false;
                this.$emit("cancelTime", this.isShow);
                this.$emit("changeTime", value);
            },
        },
    }
</script>